import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admin-used-cars"
export default class extends Controller {
  static targets = ["checkbox", "approveButton", "rejectButton", "selectAll"]

  connect() {
    this.updateButtonStates()
  }

  updateButtonStates() {
    const anyChecked = this.checkboxTargets.some(checkbox => checkbox.checked)

    if (this.hasApproveButtonTarget) {
      this.approveButtonTarget.disabled = !anyChecked
    }

    if (this.hasRejectButtonTarget) {
      this.rejectButtonTarget.disabled = !anyChecked
    }
  }

  toggleAllCheckboxes() {
    const isChecked = this.selectAllTarget.checked
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = isChecked
    })
    this.updateButtonStates()
  }
}
